<div [ngSwitch]="screenSizeType" class="main-field">
    <big-layout [hidden]="screenSizeType != ScreenSizeTypeEnum.BIG" [deviceConfiguration]="deviceConfiguration"></big-layout>
    <small-layout [hidden]="screenSizeType != ScreenSizeTypeEnum.SMALL" [deviceConfiguration]="deviceConfiguration"></small-layout>
    <slim-layout [hidden]="screenSizeType != ScreenSizeTypeEnum.SLIM" [deviceConfiguration]="deviceConfiguration"></slim-layout>
</div>